<div [innerHTML]="content | safe: 'html'"></div>
<ng-template #dynamicContainer></ng-template>
